import axios from 'axios';

const fetchIpAddress = async () => {
  try {
    const response = await axios.get('https://api.ipify.org?format=json');
    return response.data.ip;
  } catch (error) {
    throw new Error("Error fetching the IP address");
  }
};

export default fetchIpAddress;